import { ApiError } from '@anm/api';

import { NestedItem } from '../../../helpers/createNestedListFromStringList';
import { createAction, ActionUnion } from '../../helpers/createAction';
import { FilterActions } from '../filter';
import { TemplateActions } from '../template';

import { CurrentCategoryState } from './types';

export const CATEGORY_LIST_ERROR = 'wave.video/CATEGORY_LIST_ERROR';
export const CATEGORY_LIST_REQUEST = 'wave.video/CATEGORY_LIST_REQUEST';
export const CATEGORY_LIST_SUCCESS = 'wave.video/CATEGORY_LIST_SUCCESS';
export const RESET_CURRENT_CATEGORY = 'wave.video/RESET_CURRENT_CATEGORY';
export const UPDATE_CURRENT_CATEGORY = 'wave.video/UPDATE_CURRENT_CATEGORY';

export const categoryActions = {
  getCategoryList: () => createAction(CATEGORY_LIST_REQUEST),
  getCategoryListError: (error: ApiError) =>
    createAction(CATEGORY_LIST_ERROR, error),
  getCategoryListSuccess: (list: NestedItem[], count: number) =>
    createAction(CATEGORY_LIST_SUCCESS, { list, count }),
  resetCurrentCategory: () => createAction(RESET_CURRENT_CATEGORY),
  updateCurrentCategory: (currentCategory: CurrentCategoryState) =>
    createAction(UPDATE_CURRENT_CATEGORY, { currentCategory })
};

export type CategoryActions =
  | ActionUnion<typeof categoryActions>
  | FilterActions
  | TemplateActions;
